import {
  useSendCheckoutLeadMutation,
  useSendConfirmationPageLeadMutation,
  useSendPaidLeadMutation,
  useSendPaymentPageLeadMutation,
} from '@/redux/rtk';
import { useMemo } from 'react';

export const useLeads = () => {
  const [sendCheckoutLead, sendCheckoutLeadState] =
    useSendCheckoutLeadMutation();
  const [sendPaymentPageLead, sendPaymentPageLeadState] =
    useSendPaymentPageLeadMutation();
  const [sendConfirmationPageLead, sendConfirmationPageLeadState] =
    useSendConfirmationPageLeadMutation();
  const [sendPaidLead, sendPaidLeadState] = useSendPaidLeadMutation();
  return useMemo(
    () => ({
      sendCheckoutLead,
      sendPaymentPageLead,
      sendConfirmationPageLead,
      sendPaidLead,

      sendCheckoutLeadState,
      sendPaymentPageLeadState,
      sendConfirmationPageLeadState,
      sendPaidLeadState,
    }),
    [
      sendCheckoutLead,
      sendPaymentPageLead,
      sendConfirmationPageLead,
      sendPaidLead,

      sendCheckoutLeadState,
      sendPaymentPageLeadState,
      sendConfirmationPageLeadState,
      sendPaidLeadState,
    ]
  );
};
